import { authService } from '@kitopi-com/customer-auth';
import axios from 'axios';

async function post<T>(url: string, data?: unknown): Promise<T> {
  try {
    const { idToken } = await authService.getCustomerAuthSession();
    const response = await axios.post(url, data, {
      headers: {
        Accept: 'application/json',
        Authorization: idToken?.toString() || '',
      },
    });

    return response.data;
  } catch (err) {
    console.info(`POST ${url} error:`, err);
    throw err;
  }
}

export { post };
